var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(2011 -15695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 46,
    height: 36,
    rx: 2,
    transform: "translate(-2011 15695)",
    fill: "#499af8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    d: "M2,0H44a2,2,0,0,1,2,2V14a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(-2011 15695)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(0 -0.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M9.744,0A8.724,8.724,0,0,0,1.994,4.1a1.082,1.082,0,0,0,.233,1.48L4.17,7.052a1.081,1.081,0,0,0,1.5-.187C6.795,5.452,7.631,4.638,9.393,4.638c1.385,0,3.1.891,3.1,2.235,0,1.015-.838,1.537-2.206,2.3-1.595.894-3.706,2.007-3.706,4.791v.441a1.081,1.081,0,0,0,1.081,1.081h3.263A1.081,1.081,0,0,0,12,14.409v-.26c0-1.93,5.64-2.01,5.64-7.233C17.645,2.983,13.566,0,9.744,0ZM9.292,16.816a3.119,3.119,0,1,0,3.119,3.119A3.123,3.123,0,0,0,9.292,16.816Z",
    transform: "translate(-2006.8 15701.473)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 15,
    height: 5,
    rx: 2.5,
    transform: "translate(-1986 15702.5)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 15,
    height: 5,
    rx: 2.5,
    transform: "translate(-1986 15710.5)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 15,
    height: 5,
    rx: 2.5,
    transform: "translate(-1986 15718.5)",
    fill: "#d0d0d0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.1eb4aa87233d54370035b9d71885e876.svg";
export { ForwardRef as ReactComponent };